import React from 'react';
import cn from 'classnames';
import styled from 'styled-components';
import { Spinner } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { MAX_CHARS } from '../NoteInputContext';
import { colors } from '../../../theme';
import { PrimaryButton } from '../../../Button';

export const CheckmarkAndX = ({ state, controller }) => {
  const { charLeft } = state.toObject();

  return (
    <div className="d-flex justify-content-between">
      <div>
        <span className="font-size-14 text-muted">*Optional</span>
      </div>
      <div className="d-flex justify-content-end">
        <div className="mb-3">
          <CharactersLeft className={cn({ 'text-danger': charLeft < 0 })}>
            {charLeft === MAX_CHARS ? `Max. 1,000 characters` : `${charLeft} characters left`}
          </CharactersLeft>
        </div>

        <div className="d-flex justify-content-end mt-1 ml-2">
          <IconBtn className="mr-1" disabled={charLeft < 0} type="submit">
            <FontAwesomeIcon icon="check" className="accept" />
          </IconBtn>
          <IconBtn onClick={() => controller.resetNote()}>
            <FontAwesomeIcon icon="xmark" />
          </IconBtn>
        </div>
      </div>
    </div>
  );
};

export function AddAndCancel({ state, controller }) {
  const { isEditing, isUploading, charLeft } = state.toObject();
  const disabledAdd = isUploading || charLeft <= 0 || charLeft === MAX_CHARS;
  const isInvisible = !isEditing && !isUploading;
  return (
    <>
      <div className="mb-3">
        <CharactersLeft data-testid="note-characters-left" className={cn({ 'text-danger': charLeft < 0 })}>
          {charLeft === MAX_CHARS ? `Max. 1,000 characters` : `${charLeft} characters left`}
        </CharactersLeft>
      </div>
      <div className={cn('flex-row mb-3', { invisible: isInvisible, 'd-flex': !isInvisible })}>
        <PrimaryButton
          onClick={() => controller.resetNote()}
          className="ml-auto mr-2"
          variant="secondary"
          disabled={isUploading}
        >
          Cancel
        </PrimaryButton>
        <PrimaryButton disabled={disabledAdd} type="submit">
          {isUploading ? <Loader /> : 'Add Note'}
        </PrimaryButton>
      </div>
    </>
  );
}

export function FooterLabel({ state }) {
  const { charLeft } = state.toObject();
  return (
    <div className="d-flex justify-content-between">
      <div>
        <span className="font-size-14 text-muted">*Optional</span>
      </div>
      <div className="d-flex justify-content-end">
        <div className="mb-3">
          <CharactersLeft className={cn({ 'text-danger': charLeft < 0 })}>
            {charLeft === MAX_CHARS ? `Max. 1,000 characters` : `${charLeft} characters left`}
          </CharactersLeft>
        </div>
      </div>
    </div>
  );
}

const Loader = () => (
  <div style={{ width: '75px' }}>
    <Spinner animation="border" variant="light" size="sm" />
  </div>
);

const CharactersLeft = styled.span`
  position: relative;
  display: block;
  float: right;
  margin-top: 4px;
  padding-right: 4px;
  font-size: 12px;
  color: ${colors.gray200};
`;

const IconBtn = styled.button`
  border-style: none;
  background-color: ${colors.gray};
  height: 24px;
  width: 24px;
  border-radius: 12px;
  font-size: 12px;

  svg {
    font-weight: bold;
    color: ${colors.gray400};

    &.accept {
      color: ${colors.blue400};
    }
  }

  &:disabled {
    background-color: ${colors.gray200};
    svg {
      color: ${colors.gray400};
    }
  }
`;
